import { call, put, select, takeEvery } from 'redux-saga/effects';

import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../../../actions/static-catalogs/time-zones';
import * as authSelectors from '../../../reducers/auth';
import * as schemas from '../../../schemas/time-zones';
import * as types from '../../../types/static-catalogs/time-zones';
import API_BASE_URL from '../../settings/apibaseurl';

/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchTimeZonesList(action) {
  try {
    const isAuth = yield select(authSelectors.isAuthenticated);
    if (isAuth) {
      const token = yield select(authSelectors.getAuthToken);
      const response = yield call(fetch, `${API_BASE_URL}/profile/timeZone`, {
        method: 'GET',
        // body: JSON.stringify({}),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      const jsonResult = yield response.json();
      if (response.status <= 300 && jsonResult.success) {
        const resultData = jsonResult.data.map((result) => camelcaseKeys(result));
        const {
          entities: { timeZones },
          result //order
        } = normalize(resultData, schemas.timeZones); //normalize data to byId and order
        yield put(actions.completeFetchingTimeZones(timeZones, result));
      } else {
        const error = {
          errorMessage: jsonResult.message,
          errorNumber: jsonResult.number
        };
        // alerts.showErrorAlertFailChanges({ error });
        yield put(actions.failFetchingTimeZones(error));
      }
    }
  } catch (err) {
    const error = {
      errorMessage: err.toString(),
      errorNumber: -1
    };
    // alerts.showErrorAlertFailChanges({ error });
    yield put(actions.failFetchingTimeZones(error));
  }
}

export function* watchFetchTimeZonesList() {
  yield takeEvery(types.TIME_ZONES_FETCH_STARTED, fetchTimeZonesList);
}
